import { InjectionToken } from '@angular/core';
import { DOMPurify } from 'dompurify';

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const DOMPurifyInjectionToken = new InjectionToken<DOMPurify>('DOMPurifyInjectionToken');
